import React from "react";
import "./tooltip.css";

const Tooltip = ({
  upArrow,
  image,
  label,
  curveRight,
  leftcurve,
  downArrow,
  zoomin,
  rotate,
  expand,
}) => {
  return (
    <div
      className="tooltips"
      style={{ flexDirection: upArrow || downArrow ? "column" : "row" }}
    >
      {upArrow && <div className="tooltip-text mediumFont">{label}</div>}
      {leftcurve && (
        <div
          className="tooltip-text mediumFont"
          style={{ paddingBottom: "0.6rem" }}
        >
          {label}
        </div>
      )}
      <img
        alt="tooltip"
        src={image}
        className="tooltip-icon"
        style={{
          maxHeight: upArrow ? "2.5rem" : zoomin || rotate ? "4rem" : "2.5rem",
          maxWidth: upArrow ? "2.5rem" : zoomin || rotate ? "4rem" : "2.5rem",
          transform: downArrow ? "rotate(180deg)" : undefined,
        }}
      />
      {curveRight && (
        <div
          className="tooltip-text mediumFont"
          style={{ paddingBottom: "0.6rem" }}
        >
          {label}
        </div>
      )}
      {(downArrow || zoomin || rotate) && (
        <div className="tooltip-text mediumFont">{label}</div>
      )}
    </div>
  );
};

export default Tooltip;
